import { BaseEditViewStore } from 'core/stores';
import { FacilityOrderNewFlowInventoryCountEditModalForm } from 'application/facility-order-new-flow-inventory/forms';
import { FacilityInventoryCountHeaderService } from "application/facility-inventory/services";
import { action } from "mobx";
import { toUTCDate } from 'core/utils';

class FacilityOrderNewFlowInventoryCountEditModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityInventoryCountHeader = componentProps.modalParams.data.facilityInventoryCountHeader;
        const service = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'facility-order-new-flow-inventory-edit-modal',
            Form: FacilityOrderNewFlowInventoryCountEditModalForm,
            id: facilityInventoryCountHeader && facilityInventoryCountHeader.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        return {
                            ...facilityInventoryCountHeader
                        };
                    },
                    create: async resource => {
                        const response = await service.createFacilityInventoryCountHeaderAndDetails(resource);
                        return response.data;
                    },
                    update: async resource => {
                        const response = await service.update(resource);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderNewFlowInventoryCountEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrder = componentProps.modalParams.data.facilityOrder;
        this.facilityInventoryCountHeader = facilityInventoryCountHeader;
        this.refreshInventoryCalculation = componentProps.modalParams.data.refreshInventoryCalculation;
        this.getFacilityOrderStatuses = componentProps.modalParams.data.getFacilityOrderStatuses;
    }

    @action
    async initialize() {
        if (this.isEdit) {
            await this.getResource(this.id);
        } else {
            this.form.clear();
            this.form.$("countDate").value = new Date();
        }
    }

    @action.bound
    async createResource(resource) {
        if (this.facilityOrder && (!resource.countDate || (new Date(toUTCDate(this.facilityOrder.nextDeliveryDate)) < new Date(toUTCDate(resource.countDate))))) {
            this.rootStore.notificationStore.error("Count Date must be before the Delivery Date.");
            return;
        }

        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            var response = await this.actions.create({ countDate: resource.countDate, facilityId: this.facilityOrder.facilityId, facilityOrderId: this.facilityOrder.id });

            if (this.getFacilityOrderStatuses) {
                await this.getFacilityOrderStatuses();
            }

            if (response.id) {
                this.facilityOrder.facilityInventoryCountHeaderId = response.id;

                if (this.facilityOrder.missingInventoryCount) {
                    this.facilityOrder.missingInventoryCount = !this.facilityOrder.missingInventoryCount;
                }
            }

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            this.rootStore.notificationStore.success("Inventory Count successfully created.");
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    @action.bound
    async updateResource(resource) {
        if (this.facilityOrder && (!resource.countDate || (new Date(toUTCDate(this.facilityOrder.nextDeliveryDate)) < new Date(toUTCDate(resource.countDate))))) {
            this.rootStore.notificationStore.error("Count Date must be before the Delivery Date.");
            return;
        }

        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            if (this.refreshInventoryCalculation) {
                await this.refreshInventoryCalculation();
            }

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            this.rootStore.notificationStore.success("Inventory Count successfully updated.");
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderNewFlowInventoryCountEditModalStore;
